import axios from "axios";
import { create } from "zustand";
import dayjs from "dayjs";

const couponStore = create((set) => ({
  coupon: null,
  isLoading: true,

  couponForm: {
    couponName: "",
    shortDescription: "",
    discount: "",
    minOrderValue: "",
    totalNoOfVoucher: "",
    validityDate: null,
    publish: true,
  },

  validationCouponForm: {
    couponName: false,
    shortDescription: false,
    discount: false,
    minOrderValue: false,
    totalNoOfVoucher: false,
    validityDate: false,
  },

  setValidationCouponForm: ({ name, value }) => {
    set((state) => {
      return {
        validationCouponForm: {
          ...state.validationCouponForm,
          [name]: value,
        },
      };
    });
  },

  setCouponForm: ({ name, value }) => {
    set((state) => {
      return {
        couponForm: {
          ...state.couponForm,
          [name]: value,
        },
      };
    });
  },

  clearCouponForm: () => {
    set({
      couponForm: {
        couponName: "",
        shortDescription: "",
        discount: "",
        minOrderValue: "",
        totalNoOfVoucher: "",
        validityDate: null,
        publish: true,
      },
      validationCouponForm: {
        couponName: false,
        shortDescription: false,
        discount: false,
        minOrderValue: false,
        totalNoOfVoucher: false,
        validityDate: false,
      },
    });
  },

  checkValidation: () => {
    const { couponForm, setValidationCouponForm, setCouponForm } =
      couponStore.getState();
    let flag = false;
    if (couponForm.couponName === "") {
      flag = true;
      setValidationCouponForm({ name: "couponName", value: true });
    } else {
      setValidationCouponForm({ name: "couponName", value: false });
    }
    if (couponForm.shortDescription === "") {
      flag = true;
      setValidationCouponForm({ name: "shortDescription", value: true });
    } else {
      setValidationCouponForm({ name: "shortDescription", value: false });
    }
    if (couponForm.discount === "") {
      flag = true;
      setValidationCouponForm({ name: "discount", value: true });
    } else {
      setValidationCouponForm({ name: "discount", value: false });
    }
    if (couponForm.minOrderValue === "") {
      flag = true;
      setValidationCouponForm({ name: "minOrderValue", value: true });
    } else {
      setValidationCouponForm({ name: "minOrderValue", value: false });
    }
    if (couponForm.totalNoOfVoucher === "") {
      flag = true;
      setValidationCouponForm({ name: "totalNoOfVoucher", value: true });
    } else {
      setValidationCouponForm({ name: "totalNoOfVoucher", value: false });
    }
    if (couponForm.validityDate === null || couponForm.validityDate === "") {
      flag = true;
      setCouponForm({ name: "validityDate", value: "" });
      setValidationCouponForm({ name: "validityDate", value: true });
    } else {
      setValidationCouponForm({ name: "validityDate", value: false });
    }

    if (flag) {
      return false;
    } else {
      return true;
    }
  },

  fetchAllCoupon: async () => {
    try {
      // Fetch Coupon
      const res = await axios.get("fetch-all-coupon");

      // set coupon to state
      if (res.data.coupon.length) {
        set({ coupon: res.data.coupon });
      } else {
        set({ coupon: null });
      }
      set({ isLoading: false });
    } catch (error) {
      console.log(error);
    }
  },

  createCoupon: async () => {
    try {
      const { couponForm, coupon } = couponStore.getState();

      // Create the Coupon
      const res = await axios.post("/create-coupon", couponForm);

      if (res) {
        const data = coupon ? coupon : [];
        data.push(res.data.coupon);
        set({ coupon: data });
        return true;
      }
    } catch (error) {
      console.log(error);
    }
  },

  fillUpdateCouponForm: ({ item }) => {
    set({
      couponForm: {
        couponName: item.couponName,
        shortDescription: item.shortDescription,
        discount: item.discount,
        minOrderValue: item.minOrderValue,
        totalNoOfVoucher: item.totalNoOfVoucher,
        validityDate: dayjs(new Date(item.validityDate)),
        publish: item.publish,
      },
    });
  },

  updateCoupon: async ({ couponID }) => {
    try {
      const { couponForm, coupon } = couponStore.getState();

      // update the Coupon
      const res = await axios.put(`/update-coupon/${couponID}`, couponForm);

      if (res) {
        const newCoupon = [...coupon];
        const indexCoupon = coupon.findIndex((s) => {
          return s._id === couponID;
        });
        newCoupon[indexCoupon] = res.data.coupon;

        set({ coupon: newCoupon });
        return true;
      }
    } catch (error) {
      console.log(error);
    }
  },

  updateCouponPublish: async ({ couponID, publish }) => {
    try {
      const { coupon } = couponStore.getState();

      // update the Coupon
      const res = await axios.put(`/update-coupon-publish/${couponID}`, {
        publish,
      });

      if (res) {
        const newCoupon = [...coupon];
        const indexCoupon = coupon.findIndex((s) => {
          return s._id === couponID;
        });
        newCoupon[indexCoupon] = res.data.coupon;

        set({ coupon: newCoupon });
        return true;
      }
    } catch (error) {
      console.log(error);
    }
  },
}));

export default couponStore;
